<template>
  <button class="product-item" @click="$emit('click')">
    <div class="category-image" v-if="itemImage">
      <img :src="itemImage" alt="Product image" class="product-image">
    </div>
    <div class="product-details">
      <span class="product-description">{{ description.slice(0, 13) + '...' }}</span>
      <div class=" align-items-center justify-content-between d-flex">
        <h5 class="product-price">{{ $utils.formatMoney(product.SellingIncl) }}</h5>
        <button
            class="btn btn-sm btn-outline-info info-icon"
            @click.stop.prevent="showPopover"
            ref="popoverTopBtn"
        >
          <font-awesome-icon icon="info-circle" />
        </button>
        <div @click.stop.prevent class="info-popover-container">
          <div
              ref="popoverTop"
              class="popover-content"
              :class="{ 'popover-visible': isPopoverVisible }"
          >
            <div class="popover-inner">
              <button @click.stop.prevent="hidePopover" style="margin-left: 13vh; height: 1vh; width: 1vh" class="btn-close"></button>
              <span class="product-description2" v-if="description" >{{ description }}</span>
              <span class="product-description2" v-if="description2" >{{ description2 }}</span>
              <div class="wrapper">
                <span v-show="showQty">
                  <span v-if="product.QTY > 0" class="product-status info">
                    {{ $utils.formatQTY(product.QTY) }} Available to Sale
                  </span>
                  <span v-else-if="product.QTY <= 0 && !product.StockSetting.NonStock" class="product-status danger">
                    Not in Stock
                  </span>
                  <span v-else-if="product.StockSetting.NonStock" class="badge bg-info">
                    Service Item
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </button>
</template>

<script>
import { createPopper } from '@popperjs/core';
import { utils as $utils } from "@/utils/utils";

export default {
  name: "ProductItem",
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    description() {
      return $utils.toPascalCase(this.product.Description);
    },
    description2() {
      return $utils.toPascalCase(this.product.Description2);
    },
    showQty() {
      let securities = this.$store.getters.getSecurities;
      if (!securities) return false;
      return !securities.hideQuantity;
    },
    itemImage() {
      return this.product.Image || this.image;
    }
  },
  data() {
    return {
      textLength: 50,
      image: require('@/assets/img/no_image_picture.png'),
      isPopoverVisible: false,
      popperInstance: null
    };
  },
  methods: {
    showPopover(event) {
      this.$emit('hide-all-popovers');
      if (this.isPopoverVisible) {
        this.hidePopover();
        return;
      }
      this.isPopoverVisible = true;
      this.createPopperInstance();
    },
    hidePopover() {
      this.isPopoverVisible = false;
    },
    createPopperInstance() {
      if (this.popperInstance) {
        this.popperInstance.destroy();
      }

      this.popperInstance = createPopper(this.$refs.popoverTopBtn, this.$refs.popoverTop, {
        placement: 'right',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8], // 8 pixels from the trigger element
            },
          },
          {
            name: 'preventOverflow',
            options: {
              padding: 8,
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.info-popover-container {
  position: relative;
  z-index: 1000; // Ensure info button is above other elements
}
.info-icon {
  margin-left: 8px;
  font-size: 0.7rem;
}

.popover-content {
  position: absolute;
  visibility: hidden;

  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

  width: 10rem;
  padding: 0.5rem;
}

.popover-visible {
  visibility: visible;
}

.popover-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 2;
}

.product-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  //padding: 5px;
  border-radius: 5px;
  box-shadow: 0 1px 5px rgba(1, 146, 247, 0.4);
  text-align: center;
  width: 120px;
  height: 120px;
  &:hover, &:focus {
    background: #0092f7;
    color: white;
    transform: scale(1.03);

    .wrapper {
      .product-description, .product-price {
        color: white;
      }
    }
  }
  &.popover-open {
    &:hover, &:focus {
      background: transparent;
      color: inherit;
      transform: scale(1);

      .wrapper {
        .product-description, .product-price {
          color: inherit;
        }
      }
    }
  }

  .category-image {
    width: 100%;
    display: flex;
    justify-content: center;

    .product-image {
      margin-top: 5px;
      width: 45px;
      height: 45px;
      object-fit: cover;
      border-radius: 5px;
    }
  }

  .product-details {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    //margin-top: 5px;

    .product-description {
      font-size: 14px;
      font-weight: 500;
      color: #303030;
      word-wrap: break-word;
      line-height: 1.2;
      margin-top: 1px;
    }

    .product-description2 {
      font-size: 10px;
      font-weight: 400;
      color: #707070;
      //margin-bottom: 0.5rem;
    }

    .wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;

      .product-status {
        font-size: 8px;
        padding: 2px 8px;
        border-radius: 5px;
        font-weight: 600;
        //margin-bottom: 5px;

        &.info {
          background: #d5ebff;
          color: #003a5a;
        }

        &.danger {
          background: #fed3d1;
          color: #8e1f0b;
        }
      }
    }

    .product-price {
      font-size: 14px;
      font-weight: 700;
      color: #322f2f;
      //margin-top: 8px;
    }
  }
}

</style>
